import React from "react";
import { useState, useEffect } from 'react'
import ReactEcharts from "echarts-for-react";
import * as Constants from "../Constants";

function AttributeReduction() {
  // const [data, setData] = useState({})
  const [gotData, setGotData] = useState(false);
  const [data, setData] = useState(
    {
      "Category": {
          "0": "Direct COD",
          "13": "COD After Reductions in Basis of Property",
          "28": "COD After Reductions in Basis of Property",
          "55": "COD After Reductions in Basis of Property",
          "85": "COD After Reductions in Basis of Property",
          "147": "COD After Reductions in Foreign Tax Credits",
          "148": "Black Hole COD"
      },
      "Class": {
          "0": "Start",
          "13": "Class i",
          "28": "Class ii",
          "55": "Class iii",
          "56": "Class iv",
          "85": "Class i",
          "88": "Class ii",
          "95": "Class iii",
          "96": "Class iv",
          "147": "Foreign Tax Credits",
          "148": "Final"
      },
      "Company": {
          "0": "Parent Inc.",
          "13": "Parent Inc.",
          "28": "Parent Inc.",
          "55": "Parent Inc.",
          "85": "Parent Inc.",
          "147": "Parent Inc.",
          "148": "Parent Inc."
      },
      "Elect B5": {
          "0": true,
          "13": true,
          "28": true,
          "55": true,
          "85": false,
          "147": false,
          "148": true
      },
      "Inputs": {
          "0": null,
          "13": 1,
          "28": 1,
          "55": 1,
          "85": 0,
          "147": null,
          "148": null
      },
      "Secured CODI": {
          "0": 173748681.9,
          "13": 149572477.04000002,
          "28": 131709346.99799003,
          "55": 130135866.74297085,
          "85": 55211092.27167536,
          "147": null,
          "148": null
      },
      "Total CODI": {
          "0": 0,
          "13": 0,
          "55": 0,
          "56": 0,
          "60": 0,
          "85": 0,
          "88": 0,
          "95": 0,
          "96": 0,
          "147": 0,
          "148": 0
      },
      "Total CODI Difference": {
        "0": 0,
        "13": 0,
        "28": 0,
        "55": 0,
        "56": 0,
        "85": 0,
        "88": 0,
        "95": 0,
        "96": 0,
        "147": 0,
        "148": 0
      }
    }
  );
  
  const get_cod_changes_api = async () => {
    var secured_codi = 173748681.90
    var unsecured_codi = 48263522.75
    if (Constants.use_api) {
      try {
        const res = await fetch(`${Constants.url}/api/v1/section108/get_cod_changes/${Constants.company_name}?secured_codi=${secured_codi}&unsecured_codi=${unsecured_codi}`)
        if (res.ok) {
          const dataResponse = await res.json()
          setGotData(true);
          return dataResponse
        } else {
          console.log("ERROR: Something went wrong in get_cod_changes_api response AttributeReduction. res:")
          console.log(res)
          return null
        }
      } catch(error) {
        console.log("ERROR: Something went wrong in get_cod_changes_api response AttributeReduction.")
        return null
      }
    } else {
      await Constants.sleep(Constants.sleep_for_api_testing);
      setGotData(true);
      console.log("WARNING: Using fake data from Constants file in get_cod_changes_api API call.")
      return Constants.get_cod_changes_api_data
    }
  }

  useEffect(() => {
    get_cod_changes_api().then(dataResponse => setData(dataResponse))
  }, []);

  var option = {
      title: {
        text: gotData ? 'COD Chart' : "Loading...",
        subtext: gotData ? 'Changes in COD' : "Loading...",
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function (params) {
          var tar = params[1];
          return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value;
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        splitLine: { show: false },
        // data: ['Total', 'Rent', 'Utilities', 'Transportation', 'Meals', 'Other']
        // data: Object.entries(data["Category"])
        // .map( ([key, value]) => `${value}` )
        data: Object.entries(data["Class"])
        .map( ([key, value]) => `${value}` )
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Placeholder',
          type: 'bar',
          stack: 'Total',
          itemStyle: {
            borderColor: 'transparent',
            color: 'transparent'
          },
          emphasis: {
            itemStyle: {
              borderColor: 'transparent',
              color: 'transparent'
            }
          },
          // data: [0, 1700, 1400, 1200, 300, 0]
          // data: Object.entries(data["Total CODI Left"])
          // .map( ([key, value]) => value )
          data: Object.entries(data["Total CODI"])
          .map( ([key, value]) => value )
        },
        {
          name: 'Life Cost',
          type: 'bar',
          stack: 'Total',
          label: {
            show: true,
            position: 'inside'
          },
          // data: [2900, 1200, 300, 200, 900, 300]
          // data: Object.entries(data["Total CODI"])
          //   .map( ([key, value]) => -value )
          data: Object.entries(data["Total CODI Difference"])
            .map( ([key, value]) => value )
        }
      ]
    };
  return (
    <div style={{ height: '98vh', width: '94vw' }} >
      {(() => {
        if (data == null) {
          return (
            <p>Failed to load data.</p>
          )
        } else {
          return (
            <ReactEcharts option={option} style={{ height: '100%',  width: '100%' }} />
          )
        }
      })()}
    </div>
  );
}
export default AttributeReduction;